export const WHEEL_SEGMENTS = 12;

// Visual prize amounts for the wheel segments
export const VISUAL_PRIZE_AMOUNTS = ['?'];
